/*
 * Gratis cadeaus (instelling in de cross-sell-app, zie snippets/cadeau-config.liquid).
 *
 * Na elke wijziging in de winkelwagen: voor elke cadeauregel die nu loopt en
 * waarvan de klant (na korting, zonder de cadeaus zelf) de drempel betaalt,
 * komt elk cadeauproduct er één keer in met de regel-eigenschap _cadeau. Wat
 * niet (meer) verdiend is, gaat eruit. De korting-function maakt die regels
 * gratis. Zo rekenen balk, cadeau en korting met hetzelfde bedrag.
 *
 * Start en eind toetsen we aan de servertijd (de Date-header van cart.js),
 * niet aan de klok van de klant.
 */
(() => {
  const node = document.getElementById('cadeau-config');
  if (!node) return;
  let config;
  try {
    config = JSON.parse(node.textContent);
  } catch (e) {
    return;
  }
  const regels = (config.regels || []).filter((r) => r && r.drempel > 0 && r.producten && r.producten.length);
  if (regels.length === 0) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isCartCall = (url) => /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url));
  const origineleFetch = window.fetch.bind(window);
  let bezig = false;
  let timer = null;

  const post = (pad, body) =>
    origineleFetch(root + pad, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(body),
    }).then((r) => {
      if (!r.ok) throw new Error(pad + ' ' + r.status);
      return r;
    });

  const loopt = (regel, nu) =>
    (!regel.start || nu >= Date.parse(regel.start)) && (!regel.eind || nu <= Date.parse(regel.eind));

  // Schoenmaat in de winkelwagen ("43"), om bij sokken de passende maat te kiezen ("M (43-45)").
  function schoenmaat(items) {
    for (const item of items) {
      if (item.properties && item.properties._cadeau) continue;
      for (const optie of item.options_with_values || []) {
        const m = String(optie.value).match(/^\D{0,3}(\d{2})(?:[.,]5)?$/);
        if (m) return Number(m[1]);
      }
    }
    return null;
  }

  function kiesVariant(product, maat) {
    const beschikbaar = product.varianten.filter((v) => v.beschikbaar);
    if (beschikbaar.length <= 1) return beschikbaar[0];
    const metBereik = (v) => {
      const m = String(v.titel).match(/(\d{2})\s*-\s*(\d{2})/);
      return m ? [Number(m[1]), Number(m[2])] : null;
    };
    const passend =
      maat &&
      beschikbaar.find((v) => {
        const b = metBereik(v);
        return b && maat >= b[0] && maat <= b[1];
      });
    if (passend) return passend;
    // Passende maat uitverkocht: de dichtstbijzijnde beschikbare (schoenmaat 37 krijgt S, niet M).
    const afstand = (v) => {
      const b = metBereik(v);
      return b ? Math.min(Math.abs(maat - b[0]), Math.abs(maat - b[1])) : Infinity;
    };
    if (maat) {
      const dichtst = beschikbaar.reduce((beste, v) => (afstand(v) < afstand(beste) ? v : beste));
      if (afstand(dichtst) < Infinity) return dichtst;
    }
    // Geen maat bekend: de middelste beschikbare maat.
    return beschikbaar[Math.floor((beschikbaar.length - 1) / 2)];
  }

  async function controleer() {
    if (bezig) return;
    bezig = true;
    try {
      const antwoord = await origineleFetch(root + 'cart.js', {cache: 'no-store'});
      const nu = Date.parse(antwoord.headers.get('date')) || Date.now();
      const cart = await antwoord.json();

      const cadeauRegels = cart.items.filter((i) => i.properties && i.properties._cadeau);
      // Cadeaus van de oude EG-app (eigenschap _Gifted) zijn niet meer gratis: eruit, het eigen
      // cadeau komt ervoor in de plaats. Staan alle regels in testmodus, dan blijven ze staan.
      const egRegels = config.egWeg ? cart.items.filter((i) => i.properties && i.properties._Gifted) : [];
      const rest = cart.total_price - [...cadeauRegels, ...egRegels].reduce((som, i) => som + i.final_line_price, 0);

      // Welke cadeauproducten horen er nu in? Eén stuk per product, ook als twee regels hem geven.
      const gewenst = new Map();
      for (const regel of regels) {
        if (!loopt(regel, nu) || rest < regel.drempel) continue;
        for (const product of regel.producten) {
          if (!gewenst.has(product.productId) && product.varianten.some((v) => v.beschikbaar)) {
            gewenst.set(product.productId, product);
          }
        }
      }

      const updates = {};
      const aanwezig = new Set();
      for (const item of cadeauRegels) {
        if (!gewenst.has(item.product_id) || aanwezig.has(item.product_id)) {
          updates[item.key] = 0;
        } else {
          aanwezig.add(item.product_id);
          if (item.quantity > 1) updates[item.key] = 1;
        }
      }
      egRegels.forEach((i) => { updates[i.key] = 0; });

      const maat = schoenmaat(cart.items);
      const toevoegen = [];
      gewenst.forEach((product, productId) => {
        if (aanwezig.has(productId)) return;
        const variant = kiesVariant(product, maat);
        if (variant) toevoegen.push({id: variant.id, quantity: 1, properties: {_cadeau: '1'}});
      });

      let gewijzigd = false;
      if (Object.keys(updates).length > 0) {
        await post('cart/update.js', {updates});
        gewijzigd = true;
      }
      if (toevoegen.length > 0) {
        await post('cart/add.js', {items: toevoegen});
        gewijzigd = true;
      }

      if (gewijzigd) {
        if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        }
      }
    } catch (e) {
      console.error('[Cadeau]', e);
    } finally {
      bezig = false;
    }
  }

  const later = () => {
    clearTimeout(timer);
    timer = setTimeout(controleer, 400);
  };

  // Elke winkelwagenwijziging van de theme of een app loopt via fetch.
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input && input.url;
    const result = origineleFetch(input, init);
    if (!bezig && isCartCall(url)) result.then(later, later);
    return result;
  };

  controleer();

  // Start of eind van een regel valt terwijl de pagina openstaat: dan opnieuw kijken.
  const momenten = regels
    .flatMap((r) => [r.start, r.eind])
    .filter(Boolean)
    .map((m) => Date.parse(m) - Date.now() + 1500)
    .filter((ms) => ms > 0 && ms < 2147483647);
  momenten.forEach((ms) => setTimeout(controleer, ms));
})();
